/* eslint-disable arrow-body-style */
import http from "@/utils/http";
import { SPECIAL_GAME_CONFIG } from "@home/_config/constant";
import { IMetricsData, IStudioHeader } from "@home/pages/studio/type";
import { isSidebarGameHubDashboardPath } from "@home/pages/studio/studioHubRegistry";

import type { AxiosRequestConfig } from 'axios';
import type { ISetIntelligenceReport, IStudioCasualCompetitorsMetricsFetchParams, IStudioCasualCompetitorsMetricsResponse } from "@home/types/studio";

// 获取studio信息
export const getStudioInfo: (payload: { studio_code: string; }) => Promise<IStudioHeader> = (payload) => http({
  url: '/api/v2/dashboard/studio/info',
  method: 'post',
  data: payload,
  formatData: (data: any) => {
    const { studio_dashboard_list: studioDashboardList, game_list: gameList, ...reset } = data;
    const haveHome = studioDashboardList?.some((item: any) => {
      return item?.path === '/home';
    }) || false;
    const haveSidebarGameHub =
      studioDashboardList?.some((item: any) =>
        isSidebarGameHubDashboardPath(item?.path),
      ) || false;
    const enrichedDashboardList = studioDashboardList?.map((item: any) => {
      return {
        ...item,
        // path,
        _hubShell: isSidebarGameHubDashboardPath(item?.path)
          ? ('sidebar_game_hub' as const)
          : undefined,
      };
    });
    // 特殊游戏处理前端映射配置
    const newGameList = gameList?.map((item: any) => {
      const specialGameConfig = SPECIAL_GAME_CONFIG[item?.unified_edition_id];
      if (specialGameConfig) {
        const { gameCode, nameEn, nameCn } = specialGameConfig;
        return { ...item, specialGameCode: gameCode, game_name: nameEn, game_name_cn: nameCn };
      }
      return item;
    });
    return {
      studio_dashboard_list: enrichedDashboardList ?? studioDashboardList,
      haveHome,
      haveSidebarGameHub,
      game_list: newGameList,
      ...reset,
    };
  }
}) as Promise<IStudioHeader>;

// 获取studio专区inGameAnalytics指标卡片
export const getStudioCard: (payload: any, options?: any) => Promise<IMetricsData> = (payload, options) => http({
  url: '/api/v2/dashboard/studio/overview/card_metrics',
  method: 'post',
  data: payload,
  ...options,
}) as Promise<IMetricsData>;

// 获取的lastDate最新有数据的时间点
export const getGameLastDate: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/metrics_latestdate',
    method: 'post',
    data
  });
};

// 获取配置信息
export const getPageConfig: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/get_page_config',
    method: 'post',
    data
  });
};

// 获取七彩石注释信息
export const getExplainInfo: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/rainbow',
    method: 'post',
    data
  });
};

// 获取舆情v2卡片数据接口
export const getStudioFeedsComments: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v1/opinion_pc/feeds/comments',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// 获取studio筛选器
export const getSelectorList: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/new_selector',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// Funcom自动化报告Highlights获取默认参数值
export const getHighlightDefaultMetrics: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v1/opinion_pc/studio/highlights_metrics',
    method: 'post',
    data,
  });
};


// Funcom自动化报告Highlights获取
export const getHighlightList: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/opinions/highlights/list',
    method: 'post',
    data,
  });
};

// Funcom自动化报告Highlights保存
export const saveHighlightList: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/opinions/highlights/save',
    method: 'post',
    data,
    errorHandler: true
  });
};

// Funcom自动化报告Appendix新增
export const addAppendix: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/opinions/appendix/add',
    method: 'post',
    data,
  });
};

// Funcom自动化报告Appendix获取
export const getAppendix: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/opinions/appendix/list',
    method: 'post',
    data,
  });
};

// Funcom自动化报告Appendix编辑
export const editAppendix: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/opinions/appendix/edit',
    method: 'post',
    data,
    errorHandler: true
  });
};

// Funcom自动化报告Appendix删除
export const deleteAppendix: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/opinions/appendix/delete',
    method: 'post',
    data,
    errorHandler: true
  });
};

// studio 舆情页面报告增删改查
// Highlights/ Gpt Summary/ Appendix

// 新增
export const addReportSummary: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/opinions_content/add',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// 删除
export const deleteReportSummary: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/opinions_content/delete',
    method: 'delete',
    data,
    ignoreRequestId: false,
  });
};

// 编辑
export const editReportSummary: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/opinions/gpt_summary/save',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// 获取
export const getReportSummary: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/opinions/gpt_summary/get',
    method: 'post',
    data,
    ignoreRequestId: true,
  });
};

// 获取presentation筛选器
export const getPresentationFilter: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v1/util/studiohub/resource/report/filter',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// 获取Presentation报告
export const getPresentationReport: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v1/util/studiohub/resource/report',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// 获取Module内容
export const getModuleContent: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/module_content/list',
    method: 'post',
    data,
    ignoreRequestId: true,
  });
};

// 保存Module内容
export const saveModuleContent: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/module_content/save',
    method: 'post',
    data,
    ignoreRequestId: true,
  });
};

export const getSocialSeletorOptions: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/social/select',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

export const getSocialOverallIndex: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/social/overall_index',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

export const getCasualOverviewInfo: (data: { studio_code: string; }) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/casual_hub/overview/info',
    method: 'post',
    data,
  });
};

export const getCommonApi: (data: any, api: string) => Promise<any> = (data, api) => {
  return http({
    url: api,
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// studio- In-game Analytics卡片跳转
export const getCardJump: (data: any) => Promise<any> =
(data) => {
  return http({
    url: '/api/v2/dashboard/studio/game/contents',
    method: 'post',
    data
  });
};

// 获取KPI趋势图事件数据
export const getKpiTrendEventData: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/kpi/event_list',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// 设置Intelligence报告
export const setIntelligenceReport: (data: ISetIntelligenceReport) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/intelligence/set_report',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// 编辑Intelligence报告内容（标签/介绍）
export const editIntelligenceReport: (data: {
  studio_code: string;
  resource_id: string;
  introduction?: string;
  introduction_en?: string;
  tag?: string[];
  tag_en?: string[];
}) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/intelligence/edit_report',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// ==================== PR Hub 接口 ====================

// PR Hub 获取游戏列表 + 渠道枚举
export const getPrGamesWithChannels: (data: {
  studio_code: string;
  unified_edition_ids: string[];
}) => Promise<any> = (data) => {
  return http({
    url: '/api/v2/dashboard/studio/pr/games',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// PR Hub 趋势图事件时间线数据（mentions_stats_timeline）
export const getPrMentionStatsTimeline: (data: any) => Promise<any> = (data) => {
  return http({
    url: '/api/v1/opinion_pc/overview/mentions_stats_timeline',
    method: 'post',
    data,
    ignoreRequestId: false,
  });
};

// Studio 游戏权限联系人（游戏内分析无权限提示）
export const getGamePermissionContact = (payload: {
  studio_code: string;
  game_code: string;
}): Promise<{ emails: string[]; }> => http({
  url: '/api/v2/dashboard/studio/game/permission_contact',
  method: 'post',
  data: payload,
}) as Promise<{ emails: string[]; }>;

// ==================== 竞品页接口 ====================

// 竞品指标查询
export const fetchStudioCasualCompetitorsMetrics: (
  type: string,
  data: IStudioCasualCompetitorsMetricsFetchParams,
  config?: AxiosRequestConfig,
) => IBaseResponse<IStudioCasualCompetitorsMetricsResponse> = (type, data, config) => {
  return http({
    ...config,
    url: '/api/v1/intelligence_pc/studio_hub/competitor/metrics',
    method: 'post',
    data,
    params: { type },
    rawData: true,
  }) as any;
};
